import { render, staticRenderFns } from "./MediaCard.vue?vue&type=template&id=18b81ecd&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"
import style0 from "./MediaCard.vue?vue&type=style&index=0&id=18b81ecd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b81ecd",
  null
  
)

export default component.exports